import { observable} from 'mobx';
import { observer } from 'mobx-react-lite';

let root = observable({
  loading:0
})

export default root;
